.label {
  margin-top: 0.75rem;
  margin-bottom: 0.5rem;
  padding-left: 0.75rem;
  color: var(--h5w-selector-groupLabel--color, gray);
  text-transform: uppercase;
  font-size: 0.75em;
  font-weight: 600;
}

.options {
  display: flex;
  flex-direction: column;
}

.option {
  composes: btnClean from '../utils.module.css';
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  white-space: nowrap;
}

.option:hover {
  background-color: var(--h5w-selector-option-hover--bgColor, whitesmoke);
}

.optionText {
  margin-left: 0.375rem;
}
